import React, { Component, Fragment } from "react";
import { Row, Icon, Progress, Modal } from "antd";
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";
import Photo from "../../../components/phototheque/Photo";
import { getMedias } from "../../../redux/actions/photothequeActions";
import Pagination from "./PaginationContainer";
import ConfirmButton from "./../../../components/buttons/ConfirmButton";

import FileSaver from "file-saver";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import axios from "axios";
import { get, getFilename, forceDownload, getFilenameEcosystem } from "./photo.utils";
import { ECOSYSTEM_ID, roles } from "../../../configs/constants";
const departments = require("./../../../containers/activite/map/departments.json");

const MEDIA_DOWNLOAD_URL = process.env.REACT_APP_API + "/api/media/download/";

const MILESTONES_INIT = [1, 5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 95, 99];
const STEPS = { 1: "Récupération des ids des photos", 2: "Récupération des photos", 3: "Création du fichier zip" };

class Gallery extends Component {
  state = {
    checkedArray: Array(this.props.medias.length).fill(false),
    step: 1,
    isAllSelected: false,
    progressBarPercent3: 0,
    progressBarPercent2: 0,
    progressBarPercent: 0,
    isProgressDisplay: false,
    milestones: MILESTONES_INIT
  };

  renderMedias() {
    const { medias, userRoleId } = this.props;
    const { isAllSelected, checkedArray } = this.state;
    const mediaCards = [];
    for (let i = 0; i < medias.length; i++) {
      const media = medias[i];

      mediaCards.push(
        <Photo
          key={i}
          media={media}
          checked={checkedArray[i]}
          onCheck={() => {
            const newCheckedArray = [...checkedArray];
            newCheckedArray[i] = !checkedArray[i];
            this.setState({ checkedArray: newCheckedArray });
          }}
          userRoleId={userRoleId}
          zipcode={departments
            .filter(dep => {
              const salepoint = media.salepoint || {};
              const pdcZipCode = get(["salepoint", "adresse", "cp"], media);
              const pdcZipCodeAlt = get(["salepoint", "zip_code"], media);
              const zip_code = pdcZipCode || pdcZipCodeAlt;
              const pdcDepartmentNb = zip_code
                ? zip_code.toString().slice(0, -3) //version hors pharma
                : salepoint.department; // version pharma}}
              return dep.code === pdcDepartmentNb;
            })
            .map(dep => dep.code)}
        />
      );
    }

    return mediaCards.length > 0 ? (
      <div>
        <div className="p-phototheque-select p-mrg-top">
          <div
            className={`p-btn p-btn-light-orange`}
            onClick={() =>
              this.setState({
                isAllSelected: !isAllSelected,
                checkedArray: Array(medias.length).fill(!isAllSelected)
              })
            }
          >
            {isAllSelected ? (
              <Fragment>
                Désélectionner toutes les photos
                <span className="p-pdg-left-s p-phototheque-select-icon">
                  <Icon type="close" />
                </span>
              </Fragment>
            ) : (
              <Fragment>Sélectionner toutes les photos</Fragment>
            )}
          </div>
          {isAllSelected || checkedArray.some(check => check) ? (
            <ConfirmButton
              classes="p-mrg-left"
              label="Télécharger les photos sélectionnées de la page"
              onClick={() => {
                medias
                  .filter((_, i) => checkedArray[i])
                  .map(media => {
                    const fileName = getFilename(media);

                    return {
                      downloadUrl: MEDIA_DOWNLOAD_URL + media._id,
                      name: fileName
                    };
                  })
                  .forEach(image => forceDownload(image.downloadUrl, image.name + ".jpg"));
              }}
            />
          ) : null}
          <Modal title="Téléchargement des photos" visible={this.state.isProgressDisplay} footer={null} centered>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: 300
              }}
            >
              <span style={{ fontSize: "large", marginBottom: 30 }}>
                Etape {this.state.step}/3 : {STEPS[this.state.step]}
              </span>
              <Progress style={{ margin: 15 }} strokeWidth={30} percent={this.state.progressBarPercent} />
              <Progress style={{ margin: 15 }} strokeWidth={30} percent={this.state.progressBarPercent2} />
              <Progress style={{ margin: 15 }} strokeWidth={30} percent={this.state.progressBarPercent3} />
            </div>
          </Modal>

          {!isAllSelected && !checkedArray.some(check => check) ? (
            <ConfirmButton
              classes="p-mrg-left"
              label="Télécharger toutes les photos correspondant aux filtres (limité aux 200 photos les plus récentes)"
              onClick={async () => {
                await this.setState({
                  isProgressDisplay: true,
                  progressBarPercent3: 0,
                  progressBarPercent: 0,
                  progressBarPercent2: 0,
                  milestones: MILESTONES_INIT,
                  step: 1
                });
                const mediasData = [];
                for (let page = 1; page <= Math.min(this.props.pages, 10); page++) {
                  try {
                    const responseData = await axios.post(process.env.REACT_APP_API + "/api/medias/", {
                      pageSize: 20,
                      page: page,
                      project: {
                        _id: 1,
                        salepoint: 1,
                        created_at: 1,
                        sector: 1,
                        statement: 1,
                        location: 1,
                        visit_id: 1
                      },
                      match: {
                        ...this.props.currentFilters,
                        client_id: this.props.currentClientId
                      },
                      sort: { created_at: -1 }
                    });

                    if (!responseData || !responseData.data || !Array.isArray(responseData.data.docs)) return;
                    const data = responseData.data.docs;
                    mediasData.push(...data);
                  } catch (err) {
                    alert("Erreur dans le téléchargement des photos");
                  }
                  await this.setState({ progressBarPercent: parseInt((page * 100) / Math.min(this.props.pages, 10)) });
                }

                const zip = new JSZip();
                function urlToPromise(url) {
                  return new Promise(function(resolve, reject) {
                    JSZipUtils.getBinaryContent(url, function(err, data) {
                      if (err) {
                        reject(err);
                      } else {
                        resolve(data);
                      }
                    });
                  });
                }

                mediasData.forEach((media, i) => {
                  let fileName = `${i + 1}-${getFilename(media)}`;
                  if (this.props.currentClientId === ECOSYSTEM_ID) {
                    fileName = getFilenameEcosystem(media, i + 1);
                  }

                  zip.file(fileName, urlToPromise(MEDIA_DOWNLOAD_URL + media._id), {
                    binary: true
                  });
                  this.setState({ progressBarPercent2: ((i + 1) * 100) / mediasData.length, step: 2 });
                });

                zip
                  .generateAsync({ type: "blob" }, metadata => {
                    var msg = "progression : " + metadata.percent.toFixed(2) + " %";
                    if (metadata.currentFile) {
                      msg += ", current file = " + metadata.currentFile;
                    }
                    const indexStep = this.state.milestones.findIndex(step => step < metadata.percent);
                    const newMilestones = [...this.state.milestones.filter((step, i) => indexStep !== i)];
                    if (indexStep > -1) {
                      this.setState({
                        progressBarPercent3: parseInt(metadata.percent),
                        milestones: newMilestones,
                        step: 3
                      });
                    }
                    // console.log(msg);
                  })
                  .then(
                    blob => {
                      FileSaver.saveAs(blob, "toutes_photos.zip");
                      this.setState({ isProgressDisplay: false });
                    },
                    function(err) {
                      alert("Erreur de le téléchargement");
                    }
                  );
              }}
            />
          ) : null}
        </div>
        <Row style={{ color: "#ff6400" }} type="flex" justify="start">
          {mediaCards}
        </Row>
      </div>
    ) : (
      <p
        style={{
          color: "grey",
          textAlign: "center",
          fontStyle: "italic",
          marginBottom: 0
        }}
      >
        Il n'y a pas de photo dans période sélectionnée{" "}
      </p>
    );
  }

  render() {
    return (
      <div>
        <div className="p-content-item">{this.renderMedias()}</div>
        <div className="p-al-right p-mrg-ver p-mrg-bot-l">
          <Pagination
            page={this.props.page}
            pageSize={this.props.pageSize}
            pages={this.props.pages}
            getNext={page => {
              this.props.getNext(page);
              this.setState({ checkedArray: Array(this.props.medias.length).fill(false), isAllSelected: false });
            }}
          />
        </div>
      </div>
    );
  }
}

Gallery.propTypes = {
  medias: PropTypes.array
};

const mapStateToProps = (state, ownProps) => {
  const userInfosState = state.userInfos || {};
  return {
    medias: state.phototheque.medias || [],
    page: state.phototheque.page,
    pages: state.phototheque.pages,
    pageSize: state.phototheque.pageSize,
    currentFilters: state.phototheque.currentFilters,
    currentClientId: state.currentClient.id,
    userRoleId: userInfosState.role_id || roles.CLIENT
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getNext: page => {
      const nextPage = page;
      dispatch(getMedias({ page: nextPage }));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Gallery);



// WEBPACK FOOTER //
// src/containers/activite/phototeque/GalleryContainer.js